const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const downloadCatalogue = async () => {
  try {
    // Fetch PDF from backend
    const response = await fetch(`${BACKEND_URL}/api/catalogue/pdf`);
    
    if (!response.ok) {
      throw new Error('Failed to generate catalogue');
    }
    
    // Get the blob from response
    const blob = await response.blob();
    
    // Create download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Simpson_Munro_Product_Catalogue.pdf';
    
    // Trigger download
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Error downloading catalogue:', error);
    throw error;
  }
};
